// extracted by mini-css-extract-plugin
module.exports =  {"wrapper":"b13f6c073e--wrapper--pehx0","about-link":"b13f6c073e--about-link--OLstT","container":"b13f6c073e--container--Cnm3E"};